import 'svelte/internal/disclose-version';

AdminUsers[$.FILENAME] = 'src/pages/AdminUsers.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import Avatar from "../components/Avatar.svelte";
import AdminNav from "../components/AdminNav.svelte";
import EmptyState from "../components/EmptyState.svelte";
import { session } from "../lib/session.svelte.js";
import { relativeTime } from "../lib/format.js";
import { toastError, toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<p class="muted svelte-tnp63r">Loading…</p>`), AdminUsers[$.FILENAME], [[92, 4]]);
var root_1 = $.add_locations($.from_html(`<span class="badge admin svelte-tnp63r">admin</span>`), AdminUsers[$.FILENAME], [[108, 39]]);
var root_2 = $.add_locations($.from_html(`<span class="badge ok svelte-tnp63r">confirmed</span>`), AdminUsers[$.FILENAME], [[109, 36]]);
var root_3 = $.add_locations($.from_html(`<span class="badge warn svelte-tnp63r">unconfirmed</span>`), AdminUsers[$.FILENAME], [[109, 82]]);
var root_4 = $.add_locations($.from_html(`<span class="badge svelte-tnp63r">google</span>`), AdminUsers[$.FILENAME], [[110, 35]]);
var root_5 = $.add_locations($.from_html(`<button class="svelte-tnp63r">Confirm</button> <button class="svelte-tnp63r">Resend link</button>`, 1), AdminUsers[$.FILENAME], [[118, 14], [119, 14]]);
var root_6 = $.add_locations($.from_html(`<button class="danger svelte-tnp63r">Really delete</button> <button class="svelte-tnp63r">Cancel</button>`, 1), AdminUsers[$.FILENAME], [[122, 14], [123, 14]]);
var root_7 = $.add_locations($.from_html(`<button class="danger-link svelte-tnp63r">Delete</button>`), AdminUsers[$.FILENAME], [[125, 14]]);

var root_8 = $.add_locations($.from_html(`<li class="svelte-tnp63r"><div class="who svelte-tnp63r"><!> <div><strong class="svelte-tnp63r"> </strong> <span class="sub svelte-tnp63r"> </span></div></div> <div class="flags svelte-tnp63r"><!> <!> <!></div> <div class="joined svelte-tnp63r"> </div> <div class="actions svelte-tnp63r"><button class="svelte-tnp63r"> </button> <!> <!></div></li>`), AdminUsers[$.FILENAME], [
	[
		98,
		8,
		[
			[99, 10, [[101, 12, [[102, 14], [103, 14]]]]],
			[107, 10],
			[113, 10],
			[115, 10, [[116, 12]]]
		]
	]
]);

var root_9 = $.add_locations($.from_html(`<div class="pager svelte-tnp63r"><button class="svelte-tnp63r">← Previous</button> <span> </span> <button class="svelte-tnp63r">Next →</button></div>`), AdminUsers[$.FILENAME], [[133, 6, [[134, 8], [135, 8], [136, 8]]]]);
var root_10 = $.add_locations($.from_html(`<ul class="rows svelte-tnp63r"></ul> <!>`, 1), AdminUsers[$.FILENAME], [[96, 4]]);
var root_11 = $.add_locations($.from_html(`<!> <div class="toolbar svelte-tnp63r"><input type="search" placeholder="Search by name or email…" aria-label="Search users" class="svelte-tnp63r"/></div> <!>`, 1), AdminUsers[$.FILENAME], [[87, 2, [[88, 4]]]]);

const $$css = {
	hash: 'svelte-tnp63r',
	code: '\n  .toolbar.svelte-tnp63r { margin-bottom: 18px; }\n  .toolbar.svelte-tnp63r input:where(.svelte-tnp63r) {\n    width: 100%;\n    background: var(--card);\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-pill);\n    padding: 11px 18px;\n    font-size: 0.92rem;\n    outline: none;\n  }\n  .toolbar.svelte-tnp63r input:where(.svelte-tnp63r):focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }\n\n  .rows.svelte-tnp63r { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }\n  .rows.svelte-tnp63r li:where(.svelte-tnp63r) {\n    display: grid;\n    grid-template-columns: 2fr 1.2fr 1fr auto;\n    align-items: center;\n    gap: 14px;\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    padding: 12px 18px;\n  }\n  .who.svelte-tnp63r { display: flex; align-items: center; gap: 12px; min-width: 0; }\n  .who.svelte-tnp63r strong:where(.svelte-tnp63r) { display: block; font-size: 0.94rem; }\n  .sub.svelte-tnp63r { font-size: 0.8rem; color: var(--ink-faint); }\n\n  .flags.svelte-tnp63r { display: flex; gap: 6px; flex-wrap: wrap; }\n  .badge.svelte-tnp63r {\n    font-size: 0.72rem;\n    padding: 3px 9px;\n    border-radius: var(--radius-pill);\n    background: var(--card-soft);\n    border: 1px solid var(--line);\n    color: var(--ink-soft);\n  }\n  .badge.admin.svelte-tnp63r { background: var(--sage-soft); color: var(--sage); border-color: transparent; font-weight: 600; }\n  .badge.ok.svelte-tnp63r { background: var(--sage-soft); color: var(--sage); border-color: transparent; }\n  .badge.warn.svelte-tnp63r { background: var(--mustard-soft); color: var(--ink); border-color: transparent; }\n\n  .joined.svelte-tnp63r { font-size: 0.82rem; color: var(--ink-faint); }\n\n  .actions.svelte-tnp63r { display: flex; gap: 8px; justify-content: flex-end; flex-wrap: wrap; }\n  .actions.svelte-tnp63r button:where(.svelte-tnp63r) {\n    border: 1px solid var(--line-strong);\n    background: none;\n    border-radius: var(--radius-pill);\n    padding: 6px 13px;\n    font-size: 0.8rem;\n    cursor: pointer;\n    white-space: nowrap;\n  }\n  .actions.svelte-tnp63r button:where(.svelte-tnp63r):hover { border-color: var(--accent); color: var(--accent); }\n  .danger-link.svelte-tnp63r { color: var(--accent-dark); }\n  .danger.svelte-tnp63r { background: var(--accent); border-color: var(--accent); color: #fff; }\n\n  .muted.svelte-tnp63r { color: var(--ink-faint); }\n  .pager.svelte-tnp63r { display: flex; align-items: center; justify-content: center; gap: 18px; margin-top: 26px; font-size: 0.88rem; }\n  .pager.svelte-tnp63r button:where(.svelte-tnp63r) { border: 1px solid var(--line-strong); background: var(--card); border-radius: var(--radius-pill); padding: 8px 16px; cursor: pointer; }\n  .pager.svelte-tnp63r button:where(.svelte-tnp63r):disabled { opacity: 0.4; cursor: default; }\n\n  @media (max-width: 860px) {\n    .rows.svelte-tnp63r li:where(.svelte-tnp63r) { grid-template-columns: 1fr; }\n    .actions.svelte-tnp63r { justify-content: flex-start; }\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function AdminUsers($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, AdminUsers);
	$.append_styles($$anchor, $$css);

	let data = $.tag($.state(null), 'data');
	let query = $.tag($.state(""), 'query');
	let page = $.tag($.state(1), 'page');
	let loading = $.tag($.state(true), 'loading');
	let pendingDelete = $.tag($.state(null), 'pendingDelete');
	const isAdmin = $.tag($.derived(() => $.strict_equals(session.user?.role, "admin")), 'isAdmin');

	$.user_effect(() => {
		if (!$.get(isAdmin)) return;

		const params = new URLSearchParams({ page: String($.get(page)), pageSize: "25" });

		if ($.get(query).trim()) params.set("q", $.get(query).trim());

		let cancelled = false;

		$.set(loading, true);
		api.adminUsers(params).then((response) => !cancelled && $.set(data, response, true)).catch((error) => !cancelled && toastError(error.message)).finally(() => !cancelled && $.set(loading, false));

		return () => {
			cancelled = true;
		};
	});

	function replaceUser(updated) {
		$.set(
			data,
			{
				...$.get(data),
				items: $.get(data).items.map((u) => $.strict_equals(u.id, updated.id) ? updated : u)
			},
			true
		);
	}

	async function toggleRole(user) {
		try {
			replaceUser((await $.track_reactivity_loss(api.setUserRole(user.id, $.strict_equals(user.role, "admin") ? "user" : "admin")))());
			toastSuccess(`${user.displayName} is now ${$.strict_equals(user.role, "admin") ? "a member" : "an admin"}.`);
		} catch(error) {
			toastError(error.message ?? "Couldn't change that role.");
		}
	}

	async function verify(user) {
		try {
			replaceUser((await $.track_reactivity_loss(api.verifyUser(user.id)))());
			toastSuccess(`${user.email} marked as confirmed.`);
		} catch(error) {
			toastError(error.message);
		}
	}

	async function resend(user) {
		try {
			(await $.track_reactivity_loss(api.resendUserVerification(user.id)))();
			toastSuccess(`Confirmation link sent to ${user.email}.`);
		} catch(error) {
			toastError(error.message);
		}
	}

	async function confirmDelete(user) {
		try {
			(await $.track_reactivity_loss(api.deleteUser(user.id)))();

			$.set(
				data,
				{
					...$.get(data),
					items: $.get(data).items.filter((u) => $.strict_equals(u.id, user.id, false)),
					total: $.get(data).total - 1
				},
				true
			);

			toastSuccess(`Removed ${user.email}.`);
		} catch(error) {
			toastError(error.message ?? "Couldn't remove that account.");
		} finally {
			$.set(pendingDelete, null);
		}
	}

	const pageCount = $.tag($.derived(() => Math.max(1, Math.ceil(($.get(data)?.total ?? 0) / ($.get(data)?.pageSize ?? 25)))), 'pageCount');
	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_1 = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			{
				var consequent = ($$anchor) => {
					$.add_svelte_meta(
						() => EmptyState($$anchor, {
							icon: '🔒',
							title: 'Admins only',
							action: { href: "/", label: "Back home" }
						}),
						'component',
						AdminUsers,
						82,
						4,
						{ componentTag: 'EmptyState' }
					);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if (session.loaded) $$render(consequent);
					}),
					'if',
					AdminUsers,
					81,
					2
				);
			}

			$.append($$anchor, fragment_1);
		};

		var alternate_2 = ($$anchor) => {
			var fragment_3 = root_11();
			var node_2 = $.first_child(fragment_3);

			$.add_svelte_meta(() => AdminNav(node_2, { current: 'users' }), 'component', AdminUsers, 85, 2, { componentTag: 'AdminNav' });

			var div = $.sibling(node_2, 2);
			var input = $.child(div);

			$.remove_input_defaults(input);
			$.reset(div);

			var node_3 = $.sibling(div, 2);

			{
				var consequent_2 = ($$anchor) => {
					var p = root();

					$.append($$anchor, p);
				};

				var consequent_3 = ($$anchor) => {
					$.add_svelte_meta(() => EmptyState($$anchor, { icon: '🧑‍🤝‍🧑', title: 'No accounts match that' }), 'component', AdminUsers, 94, 4, { componentTag: 'EmptyState' });
				};

				var alternate_1 = ($$anchor) => {
					var fragment_5 = root_10();
					var ul = $.first_child(fragment_5);

					$.add_svelte_meta(
						() => $.each(ul, 21, () => $.get(data).items, (user) => user.id, ($$anchor, user) => {
							var li = root_8();
							var div_1 = $.child(li);
							var node_4 = $.child(div_1);

							$.add_svelte_meta(
								() => Avatar(node_4, {
									get user() {
										return $.get(user);
									},
									size: 38
								}),
								'component',
								AdminUsers,
								100,
								12,
								{ componentTag: 'Avatar' }
							);

							var div_2 = $.sibling(node_4, 2);
							var strong = $.child(div_2);
							var text = $.child(strong, true);

							$.reset(strong);

							var span = $.sibling(strong, 2);
							var text_1 = $.child(span, true);

							$.reset(span);
							$.reset(div_2);
							$.reset(div_1);

							var div_3 = $.sibling(div_1, 2);
							var node_5 = $.child(div_3);

							{
								var consequent_4 = ($$anchor) => {
									var span_1 = root_1();

									$.append($$anchor, span_1);
								};

								$.add_svelte_meta(
									() => $.if(node_5, ($$render) => {
										if ($.strict_equals($.get(user).role, "admin")) $$render(consequent_4);
									}),
									'if',
									AdminUsers,
									108,
									12
								);
							}

							var node_6 = $.sibling(node_5, 2);

							{
								var consequent_5 = ($$anchor) => {
									var span_2 = root_2();

									$.append($$anchor, span_2);
								};

								var alternate = ($$anchor) => {
									var span_3 = root_3();

									$.append($$anchor, span_3);
								};

								$.add_svelte_meta(
									() => $.if(node_6, ($$render) => {
										if ($.get(user).emailVerified) $$render(consequent_5); else $$render(alternate, -1);
									}),
									'if',
									AdminUsers,
									109,
									12
								);
							}

							var node_7 = $.sibling(node_6, 2);

							{
								var consequent_6 = ($$anchor) => {
									var span_4 = root_4();

									$.append($$anchor, span_4);
								};

								$.add_svelte_meta(
									() => $.if(node_7, ($$render) => {
										if ($.get(user).linkedGoogle) $$render(consequent_6);
									}),
									'if',
									AdminUsers,
									110,
									12
								);
							}

							$.reset(div_3);

							var div_4 = $.sibling(div_3, 2);
							var text_2 = $.child(div_4);

							$.reset(div_4);

							var div_5 = $.sibling(div_4, 2);
							var button = $.child(div_5);
							var text_3 = $.child(button, true);

							$.reset(button);

							var node_8 = $.sibling(button, 2);

							{
								var consequent_7 = ($$anchor) => {
									var fragment_6 = root_5();
									var button_1 = $.first_child(fragment_6);
									var button_2 = $.sibling(button_1, 2);

									$.delegated('click', button_1, function click_1() {
										return verify($.get(user));
									});

									$.delegated('click', button_2, function click_2() {
										return resend($.get(user));
									});

									$.append($$anchor, fragment_6);
								};

								$.add_svelte_meta(
									() => $.if(node_8, ($$render) => {
										if (!$.get(user).emailVerified) $$render(consequent_7);
									}),
									'if',
									AdminUsers,
									117,
									12
								);
							}

							var node_9 = $.sibling(node_8, 2);

							{
								var consequent_8 = ($$anchor) => {
									var fragment_7 = root_6();
									var button_3 = $.first_child(fragment_7);
									var button_4 = $.sibling(button_3, 2);

									$.delegated('click', button_3, function click_3() {
										return confirmDelete($.get(user));
									});

									$.delegated('click', button_4, function click_4() {
										return $.set(pendingDelete, null);
									});

									$.append($$anchor, fragment_7);
								};

								var consequent_9 = ($$anchor) => {
									var button_5 = root_7();

									$.delegated('click', button_5, function click_5() {
										return $.set(pendingDelete, $.get(user).id, true);
									});

									$.append($$anchor, button_5);
								};

								$.add_svelte_meta(
									() => $.if(node_9, ($$render) => {
										if ($.strict_equals($.get(pendingDelete), $.get(user).id)) $$render(consequent_8); else if ($.strict_equals($.get(user).id, session.user.id, false)) $$render(consequent_9, 1);
									}),
									'if',
									AdminUsers,
									121,
									12
								);
							}

							$.reset(div_5);
							$.reset(li);

							$.template_effect(
								($0) => {
									$.set_text(text, $.get(user).displayName);
									$.set_text(text_1, $.get(user).email);
									$.set_text(text_2, `joined ${$0 ?? ''}`);
									$.set_text(text_3, $.strict_equals($.get(user).role, "admin") ? "Make member" : "Make admin");
								},
								[() => relativeTime($.get(user).createdAt)]
							);

							$.delegated('click', button, function click() {
								return toggleRole($.get(user));
							});

							$.append($$anchor, li);
						}),
						'each',
						AdminUsers,
						97,
						6
					);

					$.reset(ul);

					var node_10 = $.sibling(ul, 2);

					{
						var consequent_10 = ($$anchor) => {
							var div_6 = root_9();
							var button_6 = $.child(div_6);
							var span_5 = $.sibling(button_6, 2);
							var text_4 = $.child(span_5);

							$.reset(span_5);

							var button_7 = $.sibling(span_5, 2);

							$.reset(div_6);

							$.template_effect(() => {
								button_6.disabled = $.get(page) <= 1;
								$.set_text(text_4, `Page ${$.get(page) ?? ''} of ${$.get(pageCount) ?? ''}`);
								button_7.disabled = $.get(page) >= $.get(pageCount);
							});

							$.delegated('click', button_6, function click_6() {
								return $.set(page, $.get(page) - 1);
							});

							$.delegated('click', button_7, function click_7() {
								return $.set(page, $.get(page) + 1);
							});

							$.append($$anchor, div_6);
						};

						$.add_svelte_meta(
							() => $.if(node_10, ($$render) => {
								if ($.get(pageCount) > 1) $$render(consequent_10);
							}),
							'if',
							AdminUsers,
							132,
							4
						);
					}

					$.append($$anchor, fragment_5);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if ($.get(loading) && !$.get(data)) $$render(consequent_2); else if (!$.get(data)?.items?.length) $$render(consequent_3, 1); else $$render(alternate_1, -1);
					}),
					'if',
					AdminUsers,
					91,
					2
				);
			}

			$.delegated('input', input, function input_1() {
				return $.set(page, 1);
			});

			$.bind_value(
				input,
				function get() {
					return $.get(query);
				},
				function set($$value) {
					$.set(query, $$value);
				}
			);

			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(isAdmin)) $$render(consequent_1); else $$render(alternate_2, -1);
			}),
			'if',
			AdminUsers,
			80,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['input', 'click']);